<template>
  <v-card>
    <div class="px-4 pt-3 pb-3 grey lighten-4 font-weight-bold flex-fill">
      Surveys
    </div>
    <v-list class="pa-0">
      <template v-for="item in options">
        <v-divider :key="item.id + '_divider'"></v-divider>
        <v-list-item :key="item.id + '_li'">
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <div class="mt-1">
              <v-chip small class="mr-1"
                >Status: {{ titleCase(item.status) }}
              </v-chip>
              <v-chip small class="mr-1"
                >Starts: {{ item.formattedStartDate }}</v-chip
              >
              <v-chip small class="mr-1"
                >Ends: {{ item.formattedEndDate }}</v-chip
              >
            </div>
          </v-list-item-content>
          <v-list-item-action>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  elevation="0"
                  fab
                  small
                  color="grey lighten-3"
                  @click="innerValue = item.id"
                  v-on="on"
                  v-bind="attrs"
                >
                  <v-icon>$right</v-icon>
                </v-btn>
              </template>
              <span>Select</span>
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import dateTimeService from "../../services/dateTimeService";

export default {
  name: "SurveySelect",
  props: {
    value: String,
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    innerValue: null,
  }),
  computed: {
    options() {
      return this.items.map((x) => {
        x.formattedStartDate =
          dateTimeService.formatDateTime(x.startDate) ?? "--";
        x.formattedEndDate = dateTimeService.formatDateTime(x.endDate) ?? "--";
        return x;
      });
    },
  },
  watch: {
    value(val, prev) {
      if (val != prev) this.innerValue = val + "";
    },
    innerValue(val, prev) {
      if (val != prev) this.$emit("input", val);
    },
  },
  methods: {
    titleCase(str) {
      str = str.toLowerCase().split(" ");
      for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }
      return str.join(" ");
    },
  },
  mounted() {
    if (this.value) this.innerValue = this.value + "";
  },
};
</script>